import AnnotationCanvas from './AnnotationCanvas';

export default AnnotationCanvas;
